// rail-library-button — shared "← Back to library" footer for the setlist rail.
//
// The library entry point used to live as a `.pv-back` button in the player
// header (cramped, esp. on mobile). It now lives at the BOTTOM of the setlist
// rail — the app's navigation surface — so the header only carries the song.
// Used by the setlist rail (setlist-rail.ts), which a single shared song gets
// too (as a one-item list), so every player keeps a way back to the library.

import { t } from './i18n.js';

export interface RailLibraryFooterOpts {
  /** Navigation on click. Defaults to a full navigation to /library. */
  onLibrary?: () => void;
}

function defaultNavigate(): void {
  if (typeof location !== 'undefined') location.assign('/library');
}

/** Build the rail footer element containing the library button. */
export function createRailLibraryFooter(opts: RailLibraryFooterOpts = {}): HTMLElement {
  const onLibrary = opts.onLibrary ?? defaultNavigate;

  const footer = document.createElement('div');
  footer.className = 'sl-rail-footer';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'sl-library-btn';
  // Leading ← arrow in its own span so CSS can space it from the label.
  const arrow = document.createElement('span');
  arrow.className = 'sl-library-btn-arrow';
  arrow.setAttribute('aria-hidden', 'true');
  arrow.textContent = '←';
  const label = document.createElement('span');
  label.className = 'sl-library-btn-label';
  label.textContent = t('common.backToLibrary');
  btn.append(arrow, label);

  btn.addEventListener('click', onLibrary);
  footer.appendChild(btn);
  return footer;
}
